import React from "react";
import { Button, Modal, ListGroup } from "react-bootstrap";
import { Link, generatePath } from "react-router-dom";
import dummyUserImage from "Assets/images/dummy_user.jpg";
import { userFullName } from "helpers/common";
import { THERAPIST_DETAIL } from "config/paths";
import { CommonToolTip } from "components/Common/Common";

const AllAssignedTherapistsPopup = ({ showPopup, closePopup, data }) => {
  return (
    <Modal
      show={showPopup}
      onHide={closePopup}
      backdrop="static"
      keyboard={false}
      centered
      className="custom-mail-sent-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Assigned Therapists</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {data?.length > 0 ? (
          <ListGroup variant="flush">
            {data.map((therapist, index) => {
              const fullName = userFullName(
                therapist?.chatterTemplateMappedTherapist
              );

              return (
                <ListGroup.Item
                  key={therapist?.therapistId || index}
                  className="d-flex align-items-center gap-3"
                >
                    <Link
                    to={generatePath(THERAPIST_DETAIL, {
                        id: therapist.therapistId,
                    })}
                    target="_blank"
                    className="d-flex align-items-center text-dark text-decoration-none gap-3"
                    >
                    <img
                        src={
                        therapist?.chatterTemplateMappedTherapist
                            ?.therapist_detail?.profile_picture ||
                        dummyUserImage
                        }
                        alt={fullName}
                        className="rounded-circle object-fit-cover"
                        style={{ height: 40, width: 40 }}
                    />
                    <span>{fullName}</span>
                    </Link>
                </ListGroup.Item>
              );
            })}
          </ListGroup>
        ) : (
          <p className="text-center m-0">No therapists assigned.</p>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center">
        <Button
          type="button"
          style={{ height: "36px", minWidth: "80px" }}
          onClick={closePopup}
          className="px-4 btn text-white commonBtn fw-sbold"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AllAssignedTherapistsPopup;
